import { render, staticRenderFns } from "./AddEditQuestionPool.vue?vue&type=template&id=caa287e2"
import script from "./AddEditQuestionPool.vue?vue&type=script&lang=js"
export * from "./AddEditQuestionPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports